import { render, staticRenderFns } from "./File.vue?vue&type=template&id=5f83636e&"
import script from "./File.js?vue&type=script&lang=js&"
export * from "./File.js?vue&type=script&lang=js&"
import style0 from "./File.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports